import React, { useState } from 'react';
import ToolLayout from '../../components/ToolLayout';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Card, CardContent } from '../../components/ui/card';
import { Code } from 'lucide-react';

const MarkdownPreviewPage = () => {
  const [markdown, setMarkdown] = useState('# Hello Markdown!\n\nStart typing your markdown here...\n\n## Features\n- **Bold text**\n- *Italic text*\n- `Code`\n- [Links](https://example.com)');

  const convertMarkdown = (text) => {
    let html = text;
    
    // Headers
    html = html.replace(/^### (.*$)/gim, '<h3 class="text-xl font-bold mb-2 mt-4">$1</h3>');
    html = html.replace(/^## (.*$)/gim, '<h2 class="text-2xl font-bold mb-3 mt-5">$1</h2>');
    html = html.replace(/^# (.*$)/gim, '<h1 class="text-3xl font-bold mb-4 mt-6">$1</h1>');
    
    // Bold
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold">$1</strong>');
    
    // Italic
    html = html.replace(/\*(.*?)\*/g, '<em class="italic">$1</em>');
    
    // Code
    html = html.replace(/`(.*?)`/g, '<code class="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded text-sm font-mono">$1</code>');
    
    // Links
    html = html.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" class="text-blue-600 dark:text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Line breaks
    html = html.replace(/\n/g, '<br>');
    
    // Lists
    html = html.replace(/^- (.*$)/gim, '<li class="ml-4">• $1</li>');
    
    return html;
  };

  return (
    <ToolLayout
      title="Markdown Preview"
      description="Write and preview Markdown in real-time. See how your markdown will be rendered."
      icon={Code}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="markdown">Markdown Input</Label>
          <Textarea
            id="markdown"
            value={markdown}
            onChange={(e) => setMarkdown(e.target.value)}
            rows={20}
            className="font-mono text-sm"
          />
        </div>

        <div>
          <Label>Preview</Label>
          <Card className="mt-2">
            <CardContent className="pt-6 min-h-[480px]">
              <div 
                className="prose dark:prose-invert max-w-none"
                dangerouslySetInnerHTML={{ __html: convertMarkdown(markdown) }}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </ToolLayout>
  );
};

export default MarkdownPreviewPage;